module.exports = function isFunction(x) {
  return typeof x === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isFunction.js
// module id = 13
// module chunks = 114276838955818